import { ClinicalAssessmentTypes } from '@sondermind/utilities/models-assessments-monolith';

export interface IAssessmentAssignmentRequest {
  assessmentIds: string[];
  clientId: string;
}

export enum AssessmentStatus {
  ASSIGNED = 'assigned',
  COMPLETED = 'completed',
  IN_PROGRESS = 'in_progress'
}

export interface IAssessmentAssignment {
  id: string;

  assessmentId: string;
  assessmentType: ClinicalAssessmentTypes;
  clientId: number;
  clinicallyRelevantAt: Date;
  clinicallyRelevantUntil: Date;
  createdAt: Date;
  currentQuestionIndex: number;
  lastUpdatedAt: Date;
  manuallySent: boolean;
  status: AssessmentStatus;
}
